import { userAgentCheck } from './UserAgentCheck';
const clickSearchformOpen = () => {
  const clickTarget = document.getElementById('js-search-button');
  const openTarget = document.getElementById('js-searchform');
  if (clickTarget !== null && openTarget !== null) {
    const msM = 200;
    let flag = false;
    const showToggleFunc = () => {
      if (flag) {
        //表示されていたら
        flag = false;
        clickTarget.style.transition = `background-color ${msM}ms`;
        clickTarget.style.backgroundColor = '';
        openTarget.style.transition = `opacity ${msM}ms`;
        openTarget.style.opacity = '0';
        const displayFunc = () => {
          //非表示にする関数を定義
          openTarget.style.display = 'none';
        };
        setTimeout(displayFunc, msM);
      } else {
        //非表示だったら
        flag = true;
        clickTarget.style.transition = `background-color ${msM}ms`;
        clickTarget.style.backgroundColor = '#dceced';
        openTarget.style.transition = `opacity ${msM}ms`;
        openTarget.style.display = 'block';
        const opacityFunc = () => {
          //非表示にする関数を定義
          openTarget.style.opacity = '1';
        };
        setTimeout(opacityFunc, 0);
      }
    };
    const invisibleFunc = (e: Event) => {
      const judgeTarget = document.querySelector('.p-gnav__icon-item--search > img');
      const judgeTarget02 = document.querySelector('.p-gnav__icon--search');
      if (flag) {
        const clickArea = e.target! as HTMLElement;
        console.log(clickArea);
        if (judgeTarget === clickArea || judgeTarget02 === clickArea) return false;
        if (!clickArea.closest('#js-searchform')) {
          showToggleFunc();
        } else {
          return false;
        }
      }
    };

    if (!userAgentCheck.Mobile) document.addEventListener('click', invisibleFunc);
    clickTarget.addEventListener('click', showToggleFunc);
  }
};

export { clickSearchformOpen };
